module.exports = __webpack_public_path__ + "static/media/location.bbd6f809.svg";